export default __webpack_public_path__ + "static/media/eb-pro-blk-banner-1.95e588fb.jpg";